import { getBackendPath, getPageFilesPaths, getPageFilesNames, getPagesPaths, getPublicPath, getStylesPath } from '@wix/anyide-template-layout';
import { foldersType } from '../types.js';
export class SiteFileStructure {
    fileStructureType;
    folderStructure;
    constructor(fileStructureType) {
        this.fileStructureType = fileStructureType;
        this.folderStructure = [
            { path: this.generateFolderPath(getBackendPath), type: foldersType.backend },
            { path: this.generateFolderPath(getPublicPath), type: foldersType.public },
            { path: this.generateFolderPath(getStylesPath), type: foldersType.styles }
        ];
    }
    generateFolderPath(getPathFunction) {
        return `${getPathFunction(this.fileStructureType)}/`;
    }
    getBackendFolderPath() {
        return getBackendPath(this.fileStructureType);
    }
    getPublicFolderPath() {
        return getPublicPath(this.fileStructureType);
    }
    getStylesFolderPath() {
        return getStylesPath(this.fileStructureType);
    }
    getPagesPaths() {
        return getPagesPaths(this.fileStructureType);
    }
    getPagesPathsForType(type) {
        const paths = this.getPagesPaths();
        const pathForType = paths[type];
        if (!pathForType) {
            throw new Error(`page type "${type}" is invalid for structureType "${this.fileStructureType}"`);
        }
        return pathForType;
    }
    getPageFilesPaths(pageFolderPath) {
        return getPageFilesPaths(this.fileStructureType, pageFolderPath);
    }
    matchPagePath(filePath) {
        const pageFilesPath = this.getPagesPaths();
        const sortedPageFilesPath = Object.entries(pageFilesPath).sort((a, b) => b[1].length - a[1].length);
        for (const [type, pagePath] of sortedPageFilesPath) {
            const typeRegex = new RegExp(`^(${pagePath.map(entry => (entry.type === 'Folder' ? entry.name : '.+?')).join('/')})/(.+)`);
            const path = typeRegex.exec(filePath);
            if (path) {
                return {
                    type,
                    pagePath: path[1],
                    fileName: path[2]
                };
            }
        }
        return null;
    }
    createCodeStructureInfo(folderType) {
        return { type: 'code', isPageFile: false, folderType: folderType };
    }
    getCodeStructureInfoByFolderPath(filePath) {
        for (const folder of this.folderStructure) {
            if (filePath.startsWith(folder.path)) {
                return this.createCodeStructureInfo(folder.type);
            }
        }
    }
    getStructureInfoByFilePath(filePath) {
        const folderStructure = this.getCodeStructureInfoByFolderPath(filePath);
        if (folderStructure) {
            return folderStructure;
        }
        const pageMatch = this.matchPagePath(filePath);
        if (pageMatch) {
            const { pagePath, fileName } = pageMatch;
            const codeFiles = getPageFilesNames(this.fileStructureType, 'code');
            if (codeFiles.has(fileName)) {
                return { type: 'code', isPageFile: true, pagePath };
            }
            const documentFiles = getPageFilesNames(this.fileStructureType, 'document');
            if (documentFiles.has(fileName)) {
                return { type: 'document', isPageFile: true, pagePath };
            }
        }
        return null;
    }
}
